import React, { Component } from "react";
import { GetData } from "../../api/service";
import { IconButton, Typography } from "@material-ui/core";
import { Drawer, Menu, message } from "antd";
import {
  DownOutlined,
  MenuOutlined,
  DownCircleOutlined,
  CaretDownOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
const { SubMenu } = Menu;

const data = [
  {
    title: "HOME",
    path: "/",
    hasSubnav: false,
    subnav: [],
  },

  {
    title: "ABOUT",
    path: "",
    hasSubnav: true,
    subnav: [
      {
        title: "Message from the Principal",
        path: "/aboutus/principal-message",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Message from the Programme Officer",
        path: "/aboutus/po-message",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "About the NSS Unit, Dispur College",
        path: "/aboutus/about",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Motto",
        path: "/aboutus/motto",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "History",
        path: "/aboutus/history",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Genesis`,
        path: "/aboutus/genesis",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Symbol & Badge",
        path: "/aboutus/symbol",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Adopted Village",
        path: "/aboutus/adopted-village",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Organogram",
        path: "/organo",
        hasSubnav: false,
        subnav: [],
      },
    ],
  },
  {
    title: "PEOPLE",
    path: "##",
    hasSubnav: true,
    subnav: [
      {
        title: `Programme Officers`,
        path: "##",
        hasSubnav: true,
        subnav: [
          {
            title: `Incumbent Programme Officer`,
            path: "/administrations/presentofficer",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Former Programme Officers",
            path: "/administrations/formerofficer",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },
      {
        title: `Student Coordinators`,
        path: "##",
        hasSubnav: true,
        subnav: [
          {
            title: "Incumbent Student Coordinators",
            path: "/administrations/presentstudent",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Former Student Coordinators",
            path: "/administrations/formerstudent",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },

      {
        title: `Volunteers`,
        path: "##",
        hasSubnav: true,
        subnav: [
          {
            title: "Enrolled Volunteers",
            path: "/administrations/enrolled-volunteers",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Former Volunteers",
            path: "/administrations/former-volunteers",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },
    ],
  },

  {
    title: "INFORMATION AND REPORTS",
    path: "",
    hasSubnav: true,
    subnav: [
      // {
      //   title: "Activity Reports",
      //   path: "/activity-reports",
      //   hasSubnav: false,
      //   subnav: [],
      // },
      {
        title: "Policies, Manuals, Regulations and Guidelines",
        path: "##",
        hasSubnav: true,
        subnav: [
          {
            title: "Policies",
            path: "/policies",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Manuals",
            path: "/manuals",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Regulations",
            path: "/regulations",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Guidelines",
            path: "/guidelines",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },
      {
        title: "Administrative Reports",
        path: "##",
        hasSubnav: true,
        subnav: [
          {
            title: "Annual NSS Unit Reports",
            path: "/administrative-reports/annual-nss-unit-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "CLAC Minutes and Other MoM",
            path: "/administrative-reports/clac-minutes-mom",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Action Taken Reports",
            path: "/administrative-reports/action-taken-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Enrolment Reports",
            path: "/administrative-reports/enrolment-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Service Completion Reports",
            path: "/administrative-reports/service-completion-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Financial Reports",
            path: "/administrative-reports/financial-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "NSS Best Practices Report",
            path: "/administrative-reports/nss-best-practices-report",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Social Impact Assessment Reports",
            path: "/administrative-reports/social-impact-assessment-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Industry Collaboration Reports",
            path: "/administrative-reports/industry-collaboration-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "MoUs",
            path: "/administrative-reports/mous",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Adopted Village Reports",
            path: "/administrative-reports/adopted-village-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Achievement and Awards Reports",
            path: "/administrative-reports/achievement-and-awards-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Press & Publicity Reports",
            path: "/administrative-reports/press-publicity-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Other Reports",
            path: "/administrative-reports/other-reports",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },
      {
        title: "Activity & Event Reports",
        path: "##",
        hasSubnav: true,
        subnav: [
          {
            title: "NSS Annual Calendar",
            path: "/activity-event-reports/nss-annual-calendar",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "ELP and CBP Reports",
            path: "/activity-event-reports/elp-cbp-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Health and Wellness Activities",
            path: "/activity-event-reports/health-wellness-activities",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Environmental & Cleanliness Initiatives",
            path: "/activity-event-reports/environmental-cleanliness-initiatives",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Awareness & Social Campaigns",
            path: "/activity-event-reports/awareness-social-campaigns",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Education & Training Programmes",
            path: "/activity-event-reports/education-training-programmes",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Community Outreach & Services",
            path: "/activity-event-reports/community-outreach-services",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },
      {
        title: "Camp Reports",
        path: "##",
        hasSubnav: true,
        subnav: [
          {
            title: "Annual Camp Reports",
            path: "/camp-reports/annual-camp-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Special Camp Reports",
            path: "/camp-reports/special-camp-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "National-Level Camp Reports",
            path: "/camp-reports/national-level-camp-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Regional & State-Level Camp Reports",
            path: "/camp-reports/regional-state-level-camp-reports",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: "Thematic Camp Reports",
            path: "/camp-reports/thematic-camp-reports",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },
      // {
      //   title: "Student Registrtion Form",
      //   path: "/registration",
      //   hasSubnav: false,
      //   subnav: [],
      // },
    ],
  },
  {
        title: "STUDENT REGISTRATION FORM",
        path: "/registration",
        hasSubnav: false,
        subnav: [],
      },

  {
    title: `ACTIVITIES`,
    path: "/events",
    hasSubnav: false,
    subnav: [],
  },

  {
    title: "NEWSLETTERS",
    path: "/newsletter",
    hasSubnav: false,
    subnav: [],
  },

  {
    title: "GALLERY",
    path: "/gallery/photo",
    hasSubnav: false,
    subnav: [],
  },

  {
    title: "CONTACT US",
    path: "/contactus",
    hasSubnav: false,
    subnav: [],
  },
];

const pos = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  zIndex: 1000,
  justifyContent: "end",
};

class MultiNavBar extends Component {
  state = {
    departments: [],
    isLoaded: false,
    data: data,
    current: "/",
    openMenu: false,
  };

  // componentDidMount() {
  //   GetData(`/getdepartments`).then((resp) => {
  //     //console.log(resp)
  //     // arrange them
  //     // let arts = resp.filter(el => el.stream == 'ARTS');
  //     // let science = resp.filter(el => el.stream == 'SCIENCE');
  //     // let arts_arr = [];
  //     // arts.map((el, index) =>
  //     //   arts_arr.push({
  //     //     title: el.dept_name,
  //     //     path: `/department/${el.dept_code}`,
  //     //     hasSubnav: false,
  //     //     subnav: []
  //     //   })
  //     // )
  //     // let science_arr = [];
  //     // science.map((el, index) =>
  //     //   science_arr.push({
  //     //     title: el.dept_name,
  //     //     path: `/department/${el.dept_code}`,
  //     //     hasSubnav: false,
  //     //     subnav: []
  //     //   })
  //     // )
  //     // let arts_d = {
  //     //   title: 'Arts Departments',
  //     //   path: '',
  //     //   hasSubnav: true,
  //     //   subnav: arts_arr
  //     // }
  //     // let science_d = {
  //     //   title: 'Science Departments',
  //     //   path: '',
  //     //   hasSubnav: true,
  //     //   subnav: science_arr
  //     // }
  //     // let d = [arts_d, science_d];
  //     // let data = this.state.data;
  //     // data[4].subnav = d;
  //     // for people
  //     let teaching_people = resp.map((el, index) => {
  //       return {
  //         title: el.dept_name,
  //         path: `/department/${el.dept_code}/faculty`,
  //         hasSubnav: false,
  //         subnav: [],
  //       };
  //     });
  //     data[1]["subnav"][5]["subnav"] = teaching_people;
  //     //console.log(data)
  //     this.setState(
  //       {
  //         data: data,
  //         isLoaded: true,
  //         current: this.props.history.location.pathname,
  //       },
  //       () => {
  //         // console.log(this.state)
  //       }
  //     );
  //   });
  // }

  closeMenu = () => {
    this.setState({
      openMenu: false,
    });
  };

  handleClick = (e) => {
    if (e.key != 0) {
      this.props.history.push(e.key);
      this.setState(
        {
          current: e.key,
        },
        () => {
          this.closeMenu();
        }
      );
    } else {
      message.success("Link opend in a new tab");
    }
  };

  render() {
    return (
      <div>
        <div className="desk-menu">
          <div
            style={
              this.props.sticky
                ? {
                    ...pos,
                  }
                : null
            }
            className={`navStyle-new`}
          >
            <Menu
              onClick={this.handleClick}
              overflowedIndicator={<MenuOutlined />}
              style={{
                background: "#051744",
                border: "none",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                //  color: "#9DA0B3"
                gap: "30px",
              }}
              selectedKeys={[this.state.current]}
              //triggerSubMenuAction="click"
              // overflowedIndicator={<MenuUnfoldOutlined />}

              mode="horizontal"
            >
              {this.state.data.map((el, index) => {
                if (el.hasSubnav) {
                  return (
                    <SubMenu
                      title={
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {el.title} &nbsp;
                          <CaretDownOutlined style={{ fontSize: 12 }} />
                        </div>
                      }
                      className="navItemPandu"
                    >
                      {el.subnav.map((el1, index1) => {
                        if (el1.hasSubnav) {
                          return (
                            <SubMenu
                              title={el1.title}
                              className="navItemPandu1"
                            >
                              {el1.subnav.map((el2, index2) => (
                                <Menu.Item
                                  className="navItemPandu1"
                                  key={el2.path}
                                >
                                  {el2.title}
                                </Menu.Item>
                              ))}
                            </SubMenu>
                          );
                        } else {
                          if (el1.isLink && el1.isLink == true) {
                            return (
                              <Menu.Item className="navItemPandu1" key={0}>
                                <a
                                  className="navItemPandu1"
                                  target="_blank"
                                  href={el1.link}
                                >
                                  {el1.title}{" "}
                                </a>
                              </Menu.Item>
                            );
                          } else {
                            return (
                              <Menu.Item
                                className="navItemPandu1"
                                key={el1.path}
                              >
                                {el1.title}
                              </Menu.Item>
                            );
                          }
                        }
                      })}
                    </SubMenu>
                  );
                } else {
                  if (el.isLink && el.isLink == true) {
                    return (
                      <Menu.Item key={0} className="navItemPandu">
                        <a
                          style={{ color: "white" }}
                          target="_blank"
                          href={el.link}
                        >
                          {el.title}{" "}
                        </a>
                      </Menu.Item>
                    );
                  } else {
                    return (
                      <Menu.Item key={el.path} className="navItemPandu">
                        {el.title}
                      </Menu.Item>
                    );
                  }
                }
              })}
            </Menu>
          </div>
        </div>

        <div className="mobile-menu-div">
          <IconButton onClick={() => this.setState({ openMenu: true })}>
            <MenuOutlined style={{ fontWeight: 700 }} />
          </IconButton>
        </div>

        <Drawer
          title=""
          placement="right"
          onClose={() => this.closeMenu()}
          open={this.state.openMenu}
        >
          <Menu
            onClick={this.handleClick}
            selectedKeys={[this.state.current]}
            overflowedIndicator={<MenuUnfoldOutlined />}
            mode="inline"
          >
            {this.state.data.map((el, index) => {
              if (el.hasSubnav) {
                return (
                  <SubMenu title={el.title}>
                    {el.subnav.map((el1, index1) => {
                      if (el1.hasSubnav) {
                        return (
                          <SubMenu title={el1.title}>
                            {el1.subnav.map((el2, index2) => (
                              <Menu.Item key={el2.path}>{el2.title}</Menu.Item>
                            ))}
                          </SubMenu>
                        );
                      } else {
                        return (
                          <Menu.Item key={el1.path}>{el1.title}</Menu.Item>
                        );
                      }
                    })}
                  </SubMenu>
                );
              } else {
                return <Menu.Item key={el.path}>{el.title}</Menu.Item>;
              }
            })}
          </Menu>
        </Drawer>
      </div>
    );
  }
}

export default MultiNavBar;

// class OneNavBar extends Component {
//   state = {
//     hover: false
//   }

//   onMouseEnter = () => {
//     this.setState({
//       hover: true
//     })
//   }

//   onMouseLeave = () => {
//     this.setState({
//       hover: false
//     })
//   }

//   render() {

//     return (
//       <div
//         style={{
//           padding: '10px 10px 10px 10px',
//           cursor: 'pointer',
//           position: 'relative',
//           color: this.props.color

//         }}

//         onMouseEnter={this.onMouseEnter}
//         onMouseLeave={this.onMouseLeave}
//         onMouseOver={this.onMouseEnter}
//         onClick={() => !this.props.hasSubnav ? this.props.history.push(this.props.path) : null}
//       >

//         <Typography
//           variant="subtitle2"
//         >
//           {this.props.title}
//         </Typography>

//         {this.props.hasSubnav && this.state.hover ? (<div
//           style={{
//             backgroundColor: this.props.backgroundColor,
//             position: 'absolute',
//             minWidth: this.props.width,
//             zIndex: 999,
//             display: 'grid',
//             gridTemplateRows: '1fr',
//             boxShadow: '1px 1px 3px rgba(0,0,0,0.3)'
//           }}
//         >

//           {this.props.subnav.map((el, index) =>
//             <OneSideNav
//               key={index}
//               {...el}
//               width={this.props.width}
//               color={this.props.color}
//               backgroundOfNav={this.props.backgroundOfNav}
//               backgroundColor={this.props.backgroundColor}
//               textColor={this.props.textColor}
//               history={this.props.history}
//             />
//           )}

//         </div>) : null}
//       </div>
//     )
//   }
// }

// class OneSideNav extends Component {
//   state = {
//     hover: false
//   }
//   onMouseEnter = () => {
//     this.setState({
//       hover: true
//     })
//   }

//   onMouseLeave = () => {
//     this.setState({
//       hover: false
//     })
//   }
//   render() {
//     return (
//       <div
//         style={{
//           color: this.props.textColor,
//           backgroundColor: this.props.backgroundColor,
//           position: 'relative',
//           minWidth: this.props.width,
//           padding: '10px',
//           borderBottom: 'solid thin lightgrey',
//           borderRight: 'solid thin lightgrey',
//           boxShadow: '1px 2px 3px rgba(0,0,0,0.3)',

//         }}
//         onClick={() => !this.props.hasSubnav ? this.props.history.push(this.props.path) : null}

//         onMouseEnter={this.onMouseEnter}
//         onMouseLeave={this.onMouseLeave}
//         onMouseOver={this.onMouseEnter}
//       >
//         <font style={{ fontSize: '0.8em' }}>{this.props.title}</font>  {this.props.hasSubnav ? (<span
//           className="fa fa-angle-right"
//           style={{
//             fontSize: '0.6em',
//             float: 'right',
//             marginTop: '8px'

//           }}></span>) : null}

//         {this.props.hasSubnav && this.state.hover ? (
//           <div
//             style={{
//               position: "absolute",
//               zIndex: 999,
//               left: 0,
//               marginLeft: this.props.width,
//               top: 0,
//               backgroundColor: this.props.backgroundColor
//             }}
//           >
//             {this.props.subnav.map((el, index) =>
//               <OneSideNav
//                 key={index}
//                 {...el}
//                 width={this.props.width}
//                 color={this.props.color}
//                 backgroundOfNav={this.props.backgroundOfNav}
//                 backgroundColor={this.props.backgroundColor}
//                 history={this.props.history}
//               />
//             )}
//           </div>
//         ) : null}

//       </div>
//     )
//   }
// }
// import React, { Component } from "react";
// import { GetData } from "../../api/service";
// import { IconButton, Typography } from "@material-ui/core";
// import { Drawer, Menu, message } from "antd";
// import {
//   DownOutlined,
//   MenuOutlined,
//   DownCircleOutlined,
//   CaretDownOutlined,
//   MenuUnfoldOutlined,
// } from "@ant-design/icons";
// const { SubMenu } = Menu;

// const data = [
//   {
//     title: "Home",
//     path: "/",
//     hasSubnav: false,
//     subnav: [],
//   },
//   {
//     title: "About",
//     path: "/administrations/principal",
//     hasSubnav: true,
//     subnav: [
//       {
//         title: `AIM OF NSS`,
//         path: "/administrations/president",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: `MOTTO OF NSS`,
//         path: "/administrations/principal",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: `CORE VALUES`,
//         path: "/administrations/generalrule",
//         hasSubnav: false,
//         subnav: [],
//       },
//     ],
//   },
//   {
//     title: "Organisation",
//     path: "##",
//     hasSubnav: true,
//     subnav: [

//       {
//         title: "Course",
//         path: "/course",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Academic Calendar",
//         path: "/academiccalendar",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Evaluation System",
//         path: "/evaluationsystem",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Result",
//         path: "/students/results",
//         hasSubnav: false,
//         subnav: [],
//       },
//     ],
//   },
//   {
//     title: "Activities",
//     path: "/research",
//     hasSubnav: true,
//     subnav: [
//       {
//         title: "Research Publications",
//         path: "/research",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Research Projects",
//         path: "/research-projects",
//         hasSubnav: false,
//         subnav: [],
//       },
//     ],
//   },
//   {
//     title: "Information",
//     path: "",
//     hasSubnav: true,
//     subnav: [
//       {
//         title: "Library Home",
//         path: "###",
//         isLink: true,
//         link: "https://library.pduameraligool.ac.in/",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Previous year Question papers",
//         path: "/facility/library-previous-question-paper",
//         hasSubnav: false,
//         subnav: [],
//       },
//     ],
//   },
//   {
//     title: "Gallery",
//     path: "/iqac/about",
//     hasSubnav: true,
//     subnav: [

//       {
//         title: "About",
//         path: "/iqac/about",
//         hasSubnav: false,
//         subnav: [],
//       },

//       {
//         title: "Annual Report",
//         path: "/iqac/annual-report",
//         hasSubnav: false,
//         subnav: [],
//       },

//       {
//         title: "Minutes & Resolutions",
//         path: "/iqac/minutes",
//         hasSubnav: false,
//         subnav: [],
//       },

//     ],
//   },

//   {
//     title: `NewsLetters`,
//     path: "/students/notification",
//     hasSubnav: false,
//     subnav: [

//       {
//         title: "Routines",
//         path: "/students/routines",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Results",
//         path: "/students/results",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Exam Schedules",
//         path: "/students/exam-schedule",
//         hasSubnav: false,
//         subnav: [],
//       },

//     ],
//   },

//   {
//     title: "Alumni",
//     path: "/alumni/committee",
//     hasSubnav: true,
//     subnav: [
//       {
//         title: "About",
//         path: "/alumni/about",
//         hasSubnav: false,
//         subnav: [],
//       },
//       {
//         title: "Alumni Registration",
//         path: "/alumni/registration",
//         hasSubnav: false,
//         subnav: [],
//       },
//     ],  },
//   {
//     title: "Contact us",
//     path: "/contactus",
//     hasSubnav: false,
//     subnav: [],
//   },
// ];

// const pos = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   zIndex: 1000,
//   justifyContent: "end",
// };

// class MultiNavBar extends Component {
//   state = {
//     departments: [],
//     isLoaded: false,
//     data: data,
//     current: "/",
//     openMenu: false,
//   };

//   componentDidMount() {
//     GetData(`/getdepartments`).then((resp) => {
//       let teaching_people = resp.map((el, index) => {
//         return {
//           title: el.dept_name,
//           path: `/department/${el.dept_code}/faculty`,
//           hasSubnav: false,
//           subnav: [],
//         };
//       });
//       data[1]["subnav"][5]["subnav"] = teaching_people;
//       //console.log(data)
//       this.setState(
//         {
//           data: data,
//           isLoaded: true,
//           current: this.props.history.location.pathname,
//         },
//         () => {
//           // console.log(this.state)
//         }
//       );
//     });
//   }

//   closeMenu = () => {
//     this.setState({
//       openMenu: false,
//     });
//   };

//   handleClick = (e) => {
//     if (e.key != 0) {
//       this.props.history.push(e.key);
//       this.setState(
//         {
//           current: e.key,
//         },
//         () => {
//           this.closeMenu();
//         }
//       );
//     } else {
//       message.success("Link opend in a new tab");
//     }
//   };

//   render() {
//     return (
//       <div>
//         <div className="desk-menu">
//           <div
//             style={
//               this.props.sticky
//                 ? {
//                     ...pos,
//                   }
//                 : null
//             }
//             className={`navStyle-new`}
//           >
//             <Menu
//               onClick={this.handleClick}
//               overflowedIndicator={<MenuOutlined />}
//               style={{
//                 background: "#051744",
//                 border: "none",
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 //  color: "#9DA0B3"
//               }}
//               selectedKeys={[this.state.current]}
//               //triggerSubMenuAction="click"
//               // overflowedIndicator={<MenuUnfoldOutlined />}

//               mode="horizontal"
//             >
//               {this.state.data.map((el, index) => {
//                 if (el.hasSubnav) {
//                   return (
//                     <SubMenu
//                       title={
//                         <div style={{ display: "flex", alignItems: "center",gap:10 }}>
//                           {el.title} &nbsp;
//                           <CaretDownOutlined style={{ fontSize: 12 }} />
//                         </div>
//                       }
//                       className="navItemPandu"
//                     >
//                       {el.subnav.map((el1, index1) => {
//                         if (el1.hasSubnav) {
//                           return (
//                             <SubMenu
//                               title={el1.title}
//                               className="navItemPandu1"
//                             >
//                               {el1.subnav.map((el2, index2) => (
//                                 <Menu.Item
//                                   className="navItemPandu1"
//                                   key={el2.path}
//                                 >
//                                   {el2.title}
//                                 </Menu.Item>
//                               ))}
//                             </SubMenu>
//                           );
//                         } else {
//                           if (el1.isLink && el1.isLink == true) {
//                             return (
//                               <Menu.Item className="navItemPandu1" key={0}>
//                                 <a
//                                   className="navItemPandu1"
//                                   target="_blank"
//                                   href={el1.link}
//                                 >
//                                   {el1.title}{" "}
//                                 </a>
//                               </Menu.Item>
//                             );
//                           } else {
//                             return (
//                               <Menu.Item
//                                 className="navItemPandu1"
//                                 key={el1.path}
//                               >
//                                 {el1.title}
//                               </Menu.Item>
//                             );
//                           }
//                         }
//                       })}
//                     </SubMenu>
//                   );
//                 } else {
//                   if (el.isLink && el.isLink == true) {
//                     return (
//                       <Menu.Item key={0} className="navItemPandu">
//                         <a
//                           style={{ color: "white" }}
//                           target="_blank"
//                           href={el.link}
//                         >
//                           {el.title}{" "}
//                         </a>
//                       </Menu.Item>
//                     );
//                   } else {
//                     return (
//                       <Menu.Item key={el.path} className="navItemPandu">
//                         {el.title}
//                       </Menu.Item>
//                     );
//                   }
//                 }
//               })}
//             </Menu>
//           </div>
//         </div>

//         <div className="mobile-menu-div">
//           <IconButton onClick={() => this.setState({ openMenu: true })}>
//             <MenuOutlined style={{ fontWeight: 700 }} />
//           </IconButton>
//         </div>

//         <Drawer
//           title=""
//           placement="right"
//           onClose={() => this.closeMenu()}
//           open={this.state.openMenu}
//         >
//           <Menu
//             onClick={this.handleClick}
//             selectedKeys={[this.state.current]}
//             overflowedIndicator={<MenuUnfoldOutlined />}
//             mode="inline"
//           >
//             {this.state.data.map((el, index) => {
//               if (el.hasSubnav) {
//                 return (
//                   <SubMenu title={el.title}>
//                     {el.subnav.map((el1, index1) => {
//                       if (el1.hasSubnav) {
//                         return (
//                           <SubMenu title={el1.title}>
//                             {el1.subnav.map((el2, index2) => (
//                               <Menu.Item key={el2.path}>{el2.title}</Menu.Item>
//                             ))}
//                           </SubMenu>
//                         );
//                       } else {
//                         return (
//                           <Menu.Item key={el1.path}>{el1.title}</Menu.Item>
//                         );
//                       }
//                     })}
//                   </SubMenu>
//                 );
//               } else {
//                 return <Menu.Item key={el.path}>{el.title}</Menu.Item>;
//               }
//             })}
//           </Menu>
//         </Drawer>
//       </div>
//     );
//   }
// }

// export default MultiNavBar;

// class OneNavBar extends Component {
//   state = {
//     hover: false
//   }

//   onMouseEnter = () => {
//     this.setState({
//       hover: true
//     })
//   }

//   onMouseLeave = () => {
//     this.setState({
//       hover: false
//     })
//   }

//   render() {

//     return (
//       <div
//         style={{
//           padding: '10px 10px 10px 10px',
//           cursor: 'pointer',
//           position: 'relative',
//           color: this.props.color

//         }}

//         onMouseEnter={this.onMouseEnter}
//         onMouseLeave={this.onMouseLeave}
//         onMouseOver={this.onMouseEnter}
//         onClick={() => !this.props.hasSubnav ? this.props.history.push(this.props.path) : null}
//       >

//         <Typography
//           variant="subtitle2"
//         >
//           {this.props.title}
//         </Typography>

//         {this.props.hasSubnav && this.state.hover ? (<div
//           style={{
//             backgroundColor: this.props.backgroundColor,
//             position: 'absolute',
//             minWidth: this.props.width,
//             zIndex: 999,
//             display: 'grid',
//             gridTemplateRows: '1fr',
//             boxShadow: '1px 1px 3px rgba(0,0,0,0.3)'
//           }}
//         >

//           {this.props.subnav.map((el, index) =>
//             <OneSideNav
//               key={index}
//               {...el}
//               width={this.props.width}
//               color={this.props.color}
//               backgroundOfNav={this.props.backgroundOfNav}
//               backgroundColor={this.props.backgroundColor}
//               textColor={this.props.textColor}
//               history={this.props.history}
//             />
//           )}

//         </div>) : null}
//       </div>
//     )
//   }
// }

// class OneSideNav extends Component {
//   state = {
//     hover: false
//   }
//   onMouseEnter = () => {
//     this.setState({
//       hover: true
//     })
//   }

//   onMouseLeave = () => {
//     this.setState({
//       hover: false
//     })
//   }
//   render() {
//     return (
//       <div
//         style={{
//           color: this.props.textColor,
//           backgroundColor: this.props.backgroundColor,
//           position: 'relative',
//           minWidth: this.props.width,
//           padding: '10px',
//           borderBottom: 'solid thin lightgrey',
//           borderRight: 'solid thin lightgrey',
//           boxShadow: '1px 2px 3px rgba(0,0,0,0.3)',

//         }}
//         onClick={() => !this.props.hasSubnav ? this.props.history.push(this.props.path) : null}

//         onMouseEnter={this.onMouseEnter}
//         onMouseLeave={this.onMouseLeave}
//         onMouseOver={this.onMouseEnter}
//       >
//         <font style={{ fontSize: '0.8em' }}>{this.props.title}</font>  {this.props.hasSubnav ? (<span
//           className="fa fa-angle-right"
//           style={{
//             fontSize: '0.6em',
//             float: 'right',
//             marginTop: '8px'

//           }}></span>) : null}

//         {this.props.hasSubnav && this.state.hover ? (
//           <div
//             style={{
//               position: "absolute",
//               zIndex: 999,
//               left: 0,
//               marginLeft: this.props.width,
//               top: 0,
//               backgroundColor: this.props.backgroundColor
//             }}
//           >
//             {this.props.subnav.map((el, index) =>
//               <OneSideNav
//                 key={index}
//                 {...el}
//                 width={this.props.width}
//                 color={this.props.color}
//                 backgroundOfNav={this.props.backgroundOfNav}
//                 backgroundColor={this.props.backgroundColor}
//                 history={this.props.history}
//               />
//             )}
//           </div>
//         ) : null}

//       </div>
//     )
//   }
// }
